import { Outlet, createBrowserRouter } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import { useShallow } from 'zustand/react/shallow'

import { DocumentTitleSync } from '../components/DocumentTitle/DocumentTitleSync'
import { PageError } from '../components/Errors/PageError'
import { Forward } from '../components/Forward/Forward'
import { MainLayout } from '../layouts/MainLayout/MainLayout'
import { useAppStore } from '../store/appStore/appStore'
import { RouteConfig } from './routes'

export type CreateRouterOptions = {
  routes: RouteConfig[]
}

export const createRouter = ({ routes }: CreateRouterOptions) =>
  createBrowserRouter([
    {
      Component: () => {
        const { componentStatus, uniqueViewKey } = useAppStore(
          useShallow(({ router }) => ({
            componentStatus: router.componentStatus,
            uniqueViewKey: router.uniqueViewKey,
          })),
        )
        useEffectOnce(() => useAppStore.getState().router.startRouteWatch())

        // Title reset runs at the start of `runPageSetup` so child layout effects
        // (ViewDocumentTitle / SetDocumentTitle) populate the slice after reset.
        return (
          <MainLayout>
            {componentStatus === 'ready' && <Outlet key={uniqueViewKey} />}
            <DocumentTitleSync />
          </MainLayout>
        )
      },
      path: '/',
      errorElement: (
        <MainLayout>
          <PageError />
        </MainLayout>
      ),
      children: [
        {
          index: true,
          element: <Forward to="/dashboard" />,
        },
        ...routes,
      ],
    },
  ])
